import { Button, Col, Divider, Form, Modal, Row } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { defaultSupporterOpenEditSelector } from "store/user/(default)/supporter/default_supporter.selector";
import SupporterName from "./component/supporter_name";
import FormMultiSelect from "component/form/form_multi_select";
import { SUPPORTER_PERMISSIONS } from "store/string";
import { useSupporterEdit } from "hook/supporters/useSupporter";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogSupporterPers = () => {
  // -------------------------- VAR -----------------------------
  const { handleCloseEdit, handleEdit, loading } = useSupporterEdit();
  const [form] = Form?.useForm();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const open = useSelector(defaultSupporterOpenEditSelector);
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      title="Chỉnh sửa quyền nhân viên"
      onCancel={() => handleCloseEdit(form)}
      open={open}
      footer={null}
    >
      <Form form={form} layout="vertical" id="form-edit-permissions">
        <Divider style={{ margin: 10 }} />
        <Row>
          <Col xl={24} lg={24} md={24} xs={24}>
            <SupporterName />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <FormMultiSelect
              label="Cấp quyền lại"
              options={SUPPORTER_PERMISSIONS}
              name="supporters"
              rules={[{ required: true, message: "Điền thông tin đầy đủ" }]}
              placeholder="Quyền truy cập dành cho nhân viên"
            />
          </Col>
          <Divider style={{ margin: 10 }} />
          <Col xl={24} lg={24} md={24} xs={24}>
            <Button
              loading={loading}
              onClick={() => handleEdit(form)}
              type="primary"
              block
            >
              Lưu quyền{" "}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
export default DialogSupporterPers;
